<template>
  <div name="contents">
    <!-- Content Wrapper -->
    <div class="content-wrapper">
     <router-view></router-view>
    </div>
    <!-- /.Content Wrapper -->
  </div>
</template>
<script>
export default {
  name: "contents",
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/AdminManage/Contents.vue